import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { BadgeComponent } from '@vendasta/galaxy/badge';

@Component({
  selector: 'ai-contextual-parameters',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule, TranslateModule, BadgeComponent],
  templateUrl: './ai-contextual-parameters.component.html',
  styleUrl: './ai-contextual-parameters.component.scss',
})
export class AiContextualParametersComponent {
  parameterNames = input.required<string[]>();
}
